const CLIENT_ID = process.env.CLIENT_ID;
const CLIENT_SECRET = process.env.CLIENT_SECRET;
const FS = process.env.FS;
const SUBDOMAIN = process.env.SUBDOMAIN;
const SSO_ENABLED = process.env.SSO_ENABLED;

export { CLIENT_ID, CLIENT_SECRET, FS, SUBDOMAIN, SSO_ENABLED };
